(function($) {
  var excludeTags = [];
  var customerTags = $("#customerTags")
    .val()
    .split("|");
  for (var i = 0; i < customerTags.length; i++) {
    if (customerTags[i].indexOf("Exclude:") > -1) {
      excludeTags.push(customerTags[i].replace("Exclude:", ""));
    }
  }

  var categoryPrefixes = ["subcat_"];
  var discountPrefix = "Discount:";

  // utility functions ==========================================================
  var sortStrategy = {
    bestselling: function(a, b) {
      return b.score - a.score;
    },
    asc: function(a, b) {
      return a.title.localeCompare(b.title);
    },
    desc: function(a, b) {
      return b.title.localeCompare(a.title);
    },
    priceasc: function(a, b) {
      return a.price - b.price;
    },
    pricedesc: function(a, b) {
      return b.price - a.price;
    },
    dateasc: function(a, b) {
      return b.date.getTime() - a.date.getTime();
    },
    datedesc: function(a, b) {
      return a.date.getTime() - b.date.getTime();
    }
  };

  // Custom Rivets formatters
  rivets.formatters.productLink = function(value) {
    return "/products/" + value;
  };

  // item property getters: allows us to perform searching in them
  function getItemTitle(item) {
    return { name: "title", value: item.title };
  }

  function getItemSku(item) {
    return { name: "sku", value: item.sku };
  }

  // inserts <mark> tags in the item's property which returned by the provided getter function
  function highlightSearchTerm(item, term, itemPropertyGetter) {
    var prop = itemPropertyGetter(item);

    var regex = new RegExp(term, "i");
    var index = regex.exec(prop.value).index;
    var marked = "<mark>" + prop.value.substr(index, term.length) + "</mark>";
    var markedProp =
      prop.value.substr(0, index) +
      marked +
      prop.value.substr(index + term.length);

    var o = {};
    o[prop.name] = markedProp;

    return _.assign({}, item, o);
  }

  $(function() {
    var searchInput = $("#wholesale-search");
    var sortSelector = $("#wholesale-sort");
    var categorySelector = $("#wholesale-category");
    var review_order_button = $(".review-order.button");
    var activeSort;
    var activeCategory;
    var items;
    var cartItems = {};
    var discountValue;

    rivets.formatters.buttonText = function(quantity, item) {
      if (!item.available) {
        return '<span class="visible-xs">X</span><span class="hidden-xs">Out of Stock</span>';
      }

      if (item.inCart && quantity != cartItems[item.id]) {
        return 'Update<span class="hidden-xs"> order</span>';
      }

      if (item.inCart) {
        return 'Added<span class="hidden-xs"> to order</span>';
      }

      return 'Add<span class="hidden-xs"> to order</span>';
    };

    // sets up the sort selector
    function setupSort() {
      activeSort = sortSelector[0].options.item(sortSelector[0].selectedIndex)
        .value;
      sortSelector.change(function(e) {
        activeSort = e.target.value;
        searchInput.trigger("input");
      });
    }

    // sets up the category selector
    function setupCategorySelector() {
      activeCategory = categorySelector[0].options.item(
        categorySelector[0].selectedIndex
      ).value;
      categorySelector.change(function(e) {
        activeCategory = e.target.value;
        searchInput.trigger("input");
      });
    }

    // collects categories and populates the category selector
    function grabCategories(products) {
      const categories = products
        .map(function(product) {
          return product.categories;
        })
        .reduce(function(allCategories, currentCategories) {
          currentCategories.forEach(function(category) {
            if (!_.includes(allCategories, category)) {
              allCategories.push(category);
            }
          });
          return allCategories;
        }, []);

      categories.forEach(function(category) {
        categoryPrefixes.forEach(function(prefix) {
          if (_.startsWith(category, prefix)) {
            var categoryName = category.substr(prefix.length);
            var $option = $(document.createElement("option"))
              .attr("value", category)
              .text(categoryName.replace(/\_/g, " "));
            categorySelector.append($option);
          }
        });
      });
    }

    // sets up the search input
    function setupSearch(products) {
      // right now it only does text search on item titles and skus
      function search(term, itemPropertyGetter) {
        var filteredArray = products
          .filter(function(element) {
            return activeCategory === "all"
              ? true
              : _.includes(element.categories, activeCategory);
          })
          .filter(function(element) {
            return new RegExp(term, "i").test(
              itemPropertyGetter(element).value
            );
          });

        var result = filteredArray.sort(sortStrategy[activeSort]);

        return term !== ""
          ? result.map(function(item) {
              return highlightSearchTerm(item, term, itemPropertyGetter);
            })
          : result;
      }

      // debounce user input (basically it 'waits' a little until user stops typing)
      searchInput.bind(
        "input",
        _.debounce(function(e) {
          var result = search(e.target.value, getItemTitle);
          if (_.isEmpty(result)) {
            result = search(e.target.value, getItemSku);
          }

          // RivetsJS stupidity...
          items.splice(0);
          result.forEach(function(element) {
            items.push(element);
          });
        }, 300)
      );

      searchInput.trigger("input");
    }

    function buttonChange(e, rivets) {
      var $button = $(e.target).closest("button");
      var $input = $button.prev();
      var quantity = $input.val();

      var id = rivets.item.id;
      var inCartQuantity = cartItems[id];

      if (inCartQuantity) {
        CartJS.updateItemById(
          id,
          quantity,
          {},
          {
            success: function(cart) {
              updateCartItems(cart.items);
              rivets.item.inCart = quantity != 0;
              rivets.item.quantity = Number(quantity);
            },
            error: function() {
              rivets.item.available = false;
              rivets.item.quantity = Number(quantity);
            }
          }
        );
      } else {
        CartJS.addItem(
          id,
          quantity,
          {},
          {
            success: function(item) {
              cartItems[item.id] = quantity;
              rivets.item.inCart = quantity != 0;
              rivets.item.quantity = Number(quantity);
            },
            error: function() {
              rivets.item.available = false;
              rivets.item.quantity = Number(quantity);
            }
          }
        );
      }
    }

    function openModal(e, rivets) {
      wholesale.openProductModalFromList(rivets.item);
    }

    function checkReviewOrder(total_price) {
      if (total_price === 0) {
        review_order_button.addClass("disabled");
        review_order_button.prop("disabled", true);
      } else {
        review_order_button.removeClass("disabled");
        review_order_button.prop("disabled", false);
      }
    }

    function updateCartItems(items) {
      cartItems = items
        .map(function(item) {
          var obj = {};
          obj[item.variant_id] = item.quantity;
          return obj;
        })
        .reduce(function(acc, curr) {
          return _.assign(acc, curr);
        }, {});
    }

    function matchCartContents(items) {
      var keys = _.keys(cartItems);

      items
        .filter(function(item) {
          return keys.indexOf(String(item.id)) !== -1;
        })
        .forEach(function(item) {
          item.inCart = true;
          item.quantity = cartItems[item.id];
        });
    }

    function getAllProducts() {
      if (window.location.href.includes("/collections")) {
        return $.get(
          "/collections/" + window.location.href.split("/collections/").pop(),
          { view: "nolayout" }
        ).then(function(data) {
          return JSON.parse(data);
        });
      } else {
        return $.get("/collections/all-products", { view: "nolayout" }).then(
          function(data) {
            return JSON.parse(data);
          }
        );
      }
    }

    function getOrderScores(order) {
      if (window.location.href.includes("/collections")) {
        return $.get(
          "/collections/" + window.location.href.split("/collections/").pop(),
          {
            sort_by: order,
            view: "manual"
          }
        ).then(function(data) {
          return JSON.parse(data);
        });
      } else {
        return $.get("/collections/all-products", {
          sort_by: order,
          view: "manual"
        }).then(function(data) {
          return JSON.parse(data);
        });
      }
    }

    function removeExcludeProducts(products) {
      return products.filter(function(product) {
        for (var i = 0; i < excludeTags.length; i++) {
          if (product.tags.indexOf(excludeTags[i]) > -1) {
            return false;
          }
        }
        return true;
      });
    }

    function mergeOrderScores(products, scores) {
      discountValue = calculateDiscountValue(scores.customer);

      return products.map(function(product) {
        var score = _.find(scores.products, function(scoreItem) {
          return scoreItem.id === product.id;
        }).score;
        return _.assign(product, { score: score });
      });
    }

    function calculateDiscountValue(customer) {
      return (
        customer.tags
          .filter(function(tag) {
            return _.startsWith(tag, discountPrefix);
          })
          .map(function(tag) {
            return parseInt(tag.substring(discountPrefix.length));
          })
          .reduce(function(a, c) {
            return a + c;
          }, 0) / 100
      );
    }

    function transformItem(item) {
      var firsVariant = item.variants[0];

      var categories = item.tags.filter(function(tag) {
        return _.includes(
          categoryPrefixes,
          tag.substring(0, tag.indexOf("_") + 1)
        );
      });

      var images = item.images.map(function(image) {
        return { src: image };
      });
      
      

      var obj = {
        id: firsVariant.id,
        productId: item.id,
        body_html: item.content,
        title: item.title,
        image: images.length ? images[0].src : null,
        images: images,
        sku: firsVariant.sku,
        compare_at_price: firsVariant.compare_at_price,
        price: firsVariant.price - firsVariant.price * discountValue,
        handle: item.handle,
        date: new Date(item.created_at),
        button: buttonChange,
        modal: openModal,
        categories: categories,
        available: item.available,
        score: item.score,
        quantity: 0,
        inCart: false,
        tags: item.tags,
        isOnSale: item.tags.indexOf("subcat_onsale") >= 0 ? true : false
      };
      console.log(obj);

      obj.disabled = function(quantity) {
        return (
          !this.available ||
          (this.quantity == 0 && !this.inCart) ||
          cartItems[String(this.id)] == this.quantity
        );
      }.bind(obj);

      obj.isInCart = function(quantity) {
        return cartItems[String(this.id)] == this.quantity;
      }.bind(obj);

      return obj;
    }

    function transformProducts(products) {
      return products.map(transformItem);
    }

    // get all products and initialize
    $.when(getAllProducts(), getOrderScores("manual"))
      .then(mergeOrderScores)
      .then(removeExcludeProducts)
      .then(transformProducts)
      .done(function(orignalItems) {
        items = orignalItems.slice();
        grabCategories(orignalItems);
        setupSort();
        setupCategorySelector();
        setupSearch(orignalItems);
        checkReviewOrder(CartJS.cart.total_price);
        updateCartItems(CartJS.cart.items);
        matchCartContents(items);
        rivets.bind($("#wholesale-view"), { model: items });
      });

    $(document).on("cart.requestComplete", function(event, cart) {
      $("[data-cart-count]").html(cart.item_count);
      $("[data-cart-total]").html(Shopify.formatMoney(cart.total_price));
      checkReviewOrder(cart.total_price);
    });
  });
})(jQuery);
